import { WCHANCE_DRAW_STATUS } from '../types';

export const drawStatus = (status: string) => {
  switch (status) {
    case WCHANCE_DRAW_STATUS.won.key:
      return WCHANCE_DRAW_STATUS.won;
    case WCHANCE_DRAW_STATUS.pending.key:
      return WCHANCE_DRAW_STATUS.pending;
    case WCHANCE_DRAW_STATUS.submitted.key:
      return WCHANCE_DRAW_STATUS.submitted;
    case WCHANCE_DRAW_STATUS.lost.key:
      return WCHANCE_DRAW_STATUS.lost;
    default:
      return undefined;
  }
};
